import { combineBytes } from "../utils";
import { CAN_FUNC_TX1, CAN_FUNC_TX2, CAN_FUNC_TX3, CAN_FUNC_TX4, HEATER_STATUS_CAN_ID, HEATER_NODE_ID } from "../constants";

export function handleHeaterPacket(id, payload, heater, bleEventDispatcher) {
	if (payload.length !== 8) return false;
	if (id === CAN_FUNC_TX1 + HEATER_NODE_ID) {
		heater.running_state = payload[0];
		heater.error_state = payload[1];
		heater.pump_hz = payload[2] / 10;
		heater.target_pump_hz = payload[3] / 10;
		heater.heat_exchanger_temp = (payload[4] << 8) | payload[5];
		heater.supply_voltage = ((payload[6] << 8) | payload[7]) / 10;
		bleEventDispatcher.emit("heater", heater);
		return true;
	}

	if (id === CAN_FUNC_TX2 + HEATER_NODE_ID) {
		heater.fan_rpm = combineBytes(payload[0], payload[1]);
		bleEventDispatcher.emit("heater", heater);
		return true;
	}

	if (id === CAN_FUNC_TX3 + HEATER_NODE_ID) {
		heater.target_power = payload[1];
		const rawTemp = combineBytes(payload[2], payload[3]);
		heater.temp = rawTemp === -32768 ? null : rawTemp / 100;
		heater.ideal_temp = combineBytes(payload[4], payload[5]) / 100;
		heater.redundant_count = payload[6];
		heater.climate_control_enabled = payload[7];
		bleEventDispatcher.emit("heater", heater);
		return true;
	}

	if (id === CAN_FUNC_TX4 + HEATER_NODE_ID) {
		heater.pump_counter = ((payload[0] << 24) | (payload[1] << 16) | (payload[2] << 8) | payload[3]) >>> 0;
		heater.heater_timer = ((payload[4] << 24) | (payload[5] << 16) | (payload[6] << 8) | payload[7]) >>> 0;
		bleEventDispatcher.emit("heater", heater);
		return true;
	}

	if (id === HEATER_STATUS_CAN_ID) {
		heater.uptime = ((payload[0] << 24) | (payload[1] << 16) | (payload[2] << 8) | payload[3]) >>> 0;
		heater.turnoff_temp = combineBytes(payload[4], payload[5]) / 100;
		heater.controller_faults = payload[7];
		bleEventDispatcher.emit("heater", heater);
		return true;
	}

	return false;
}
